import TablePaginationActions from "./pagination";

export { TablePaginationActions };
